import { createServerStateStore } from "./serverState";

export interface SmsSettingsState {
  isActive: boolean;
  operationalEnabled: boolean;
  marketingEnabled: boolean;
  iysEnabled: boolean;
  netgsmSubUser: string;
  netgsmPassword: string;
  senderTitle: string;
  testPhone: string;
}

const defaultState: SmsSettingsState = {
  isActive: false,
  operationalEnabled: false,
  marketingEnabled: false,
  iysEnabled: false,
  netgsmSubUser: "",
  netgsmPassword: "",
  senderTitle: "EVREN",
  testPhone: "",
};

const store = createServerStateStore<SmsSettingsState>(
  "sms_settings",
  defaultState
);

export function getSmsSettings() {
  return store.getState();
}

export async function rehydrateSmsSettings() {
  return store.rehydrate();
}

export function subscribeSmsSettings(listener: () => void) {
  return store.subscribe(listener);
}

export async function updateSmsSettings(
  patch: Partial<SmsSettingsState>
) {
  return store.setState((prev) => ({
    ...prev,
    ...patch,
  }));
}

export async function resetSmsSettings() {
  return store.reset();
}